// extracted by mini-css-extract-plugin
export default {"processingDirectionSuccess":"Success_processingDirectionSuccess","SuccessCircleSVG":"Success_SuccessCircleSVG","subtitle":"Success_subtitle"};